import { Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { globalState } from '@/store/global';
import settings from '@/config/settings';

export default function RightTabNav() {
  const [global, setGlobal] = useRecoilState(globalState);
  const location = useLocation();
  const navigate = useNavigate();
  const tabs = global.headTabNavList;
  const open = (path: string) => {
    const tab = tabs.find((item) => item.location.pathname === path);
    if (tab) navigate({ pathname: path, search: tab.location.search, hash: tab.location.hash }, { state: tab.location.state });
  };
  const close = (path: string) => {
    if (path === settings.tabNavHomePath) return;
    const index = tabs.findIndex((tab) => tab.location.pathname === path);
    if (index < 0) return;
    if (location.pathname === path) {
      const next = tabs[index - 1] || tabs[index + 1];
      if (next) open(next.location.pathname);
      else navigate(settings.tabNavHomePath);
    }
    setGlobal((previous) => ({ ...previous, headTabNavList: previous.headTabNavList.filter((tab) => tab.location.pathname !== path) }));
  };
  return <Tabs className="workspace-tabs" type="editable-card" size="small" hideAdd
    activeKey={location.pathname} onChange={open}
    onEdit={(key, action) => { if (action === 'remove') close(String(key)); }}
    items={tabs.map((tab) => ({ key: tab.location.pathname, label: tab.menu.meta?.title || tab.location.pathname,
      closable: tab.location.pathname !== settings.tabNavHomePath }))} />;
}
